module.exports = __webpack_public_path__ + "static/product-page-left.19c1270e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product-page-left.jpg
// module id = 1506
// module chunks = 168707334958949